module.exports = __webpack_public_path__ + "static/media/iconCommitFuel.24888642.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitFuel.svg
// module id = 942
// module chunks = 0